module.exports = __webpack_public_path__ + "media/images/substained-abuse-graph-7341ab3c354345cba6ae82c1ab6a07a0.png";